/* === jn-card-hover v2 (2026-08-11) ===
   问题：商品卡开了「悬停显示第二张图」，但第二张 <img loading="lazy"> 在鼠标移上去那一刻
   往往还没开始下载，幻灯片已经切过去了，于是显示成一片空白。
   （实测集合页 243 张卡片图里 193 张是 lazy。）

   v1 的 bug：MutationObserver 一有 DOM 变化就重跑 init()，每次新建 IntersectionObserver
   顶掉旧的；而幻灯片和懒加载本身一直在改 DOM，观察器被反复替换、回调来不及触发，
   结果预热数量卡死在首屏那几张。v2 把观察器提到模块级只建一次，并只处理新增节点。

   两层：卡片接近视口 → fetchpriority=low 预热；鼠标真进来 → 提到 high。
   纯前端，不改任何商品数据；JS 失效时行为与改动前完全一致。 */
(function () {
  var SEL = '.card-gallery';
  var io = null;
  var scheduled = false;

  function secondImg(card) {
    var slides = card.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return null;
    return slides[1].querySelector('img');
  }

  function warm(card, priority) {
    var img = secondImg(card);
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) { img.dataset.jnWarmed = 'done'; return; }
    if (img.dataset.jnWarmed === 'done') return;
    if (priority !== 'high' && img.dataset.jnWarmed) return;
    try { img.setAttribute('fetchpriority', priority); } catch (e) {}
    if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    img.dataset.jnWarmed = priority === 'high' ? 'done' : 'warming';
    img.addEventListener('load', function () { img.dataset.jnWarmed = 'done'; }, { once: true });
  }

  // 观察器只建一次
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        warm(entries[i].target, 'low');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '600px 0px' });
  }

  function bind(card) {
    if (card.dataset.jnHoverBound) return;
    card.dataset.jnHoverBound = '1';
    if (io) io.observe(card); else warm(card, 'low');
    card.addEventListener('pointerenter', function () { warm(card, 'high'); }, { passive: true });
  }

  function scan() {
    scheduled = false;
    var cards = document.querySelectorAll(SEL);
    for (var i = 0; i < cards.length; i++) bind(cards[i]);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // requestIdleCallback 第二参必须是 IdleRequestOptions 对象，传 200 会抛 TypeError；
    // requestAnimationFrame 也不接受延时参数，所以不可用时直接降级 setTimeout。
    if (window.requestIdleCallback) {
      requestIdleCallback(scan, { timeout: 200 });
    } else {
      setTimeout(scan, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', schedule);

  // 只在真的新增了卡片时才重扫，且合并到一次空闲回调里
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
